import type { TableFilters } from "@/types/tableState.types";

type DashboardRequestFilterOptions = {
  currentFilters: TableFilters;
  subjectId?: string;
  fixedFilters?: TableFilters;
  excludedFilterKeys?: readonly string[];
};

export function buildDashboardRequestFilters({
  currentFilters,
  subjectId,
  fixedFilters,
  excludedFilterKeys = [],
}: DashboardRequestFilterOptions): TableFilters {
  const excludedKeys = new Set(excludedFilterKeys);
  const requestFilters = Object.fromEntries(
    Object.entries(currentFilters).filter(([key]) => !excludedKeys.has(key)),
  );

  if (subjectId) requestFilters.subject = [subjectId];

  return { ...requestFilters, ...(fixedFilters ?? {}) };
}
